import { IVehicle } from 'components/SearchBlock/CarSearch/CarSearchBlock';
import mapVehicle, { ILicencePlateVehicle } from 'components/SearchBlock/CarSearch/LicencePlate/mapVehicle';

// A saved car as returned for the account / select-own-car views.
export interface ISavedVehicle {
    plateNumber: string;
    manufacturerName: string;
    manufacturerId: string;
    modelName: string;
    modelId: string;
    engineName: string;
    engineId: string;
}

// The IVehicle built straight from the stored record (no live lookup) — used as a fallback.
const savedVehicleFallback = (vehicle: ISavedVehicle): IVehicle => ({
    manufacturer: {
        id: vehicle.manufacturerId,
        label: vehicle.manufacturerName,
    },
    model: {
        id: vehicle.modelId,
        label: vehicle.modelName,
    },
    type: {
        id: vehicle.engineId,
        label: vehicle.engineName,
    },
    licence: vehicle.plateNumber,
});

export const resolveSavedVehicle = async (
    vehicle: ISavedVehicle,
    queryLicence: (licence: string) => Promise<any>,
): Promise<IVehicle> => {
    const fallback = savedVehicleFallback(vehicle);

    if (!vehicle.plateNumber) {
        return fallback;
    }

    try {
        const response = await queryLicence(vehicle.plateNumber);
        if (response.status === 200) {
            const cars: ILicencePlateVehicle[] = response.body || [];
            const match = cars.find((car) => String(car.carId) === String(vehicle.engineId));

            if (match) {
                return mapVehicle(match, vehicle.plateNumber);
            }
        }
    } catch (e) {}

    return fallback;
};
